
import React from 'react';
import PropTypes from 'prop-types';
import { ADMIN_ID } from './config';

const CustomBubble = ({ message }) => {
  

  return (
    <div className="bubble">
      {message.id !== ADMIN_ID &&
        <p className={message.id === ADMIN_ID ? 'name-right' : 'name-left'}>{message.senderName}</p>}
      <p className={message.id === ADMIN_ID ? 'item-right' : 'item-left'}>
        {message.message}
      </p>
    </div>
  )
}

CustomBubble.defaultProps = {
  message: {}
}

CustomBubble.propTypes = {
  message: PropTypes.instanceOf(Object)
}

export default CustomBubble;